import React, { useState, useEffect } from 'react';
import { api } from '../../../common/app';
import { Toast, Button } from 'antd-mobile';
import Layout from '../component/layout'
import { useHistory } from 'react-router-dom'
import Card from '../component/card';
import moment from 'moment';
import { useUserStatus } from '../../../common/hooks/user-status';

export default (props: any) => {
  const { id } = props.match.params;
  const history = useHistory();
  // 酒店数据
  const [data, setData] = useState({} as any);
  // 酒店详情
  const [detail, setDetail] = useState({} as any);

  const { userstatus } = useUserStatus(id);
  const [loading, setLoading] = useState(true)

  // 请求酒店数据
  useEffect(() => {
    (api as any).myHotel({ meetid: id })
      .then((result: any) => {
        if (result.code === 200) {
          setData(result.result);
          setTimeout(() => {
            setLoading(false);  
          }, 500);
        }
      })
      .catch((err: any) => {
        Toast.fail(err.message || '接口请求失败');
      })
  }, []);

  useEffect(() => {
    if (data.hotel_data && data.hotel_data.id) {
      (api as any).myHotelInfo({ meetid: id, id: data.hotel_data.id })
        .then((result: any) => {
          if (result.code === 200) {
            setDetail(result.result);
          }
        })
        .catch((err: any) => {
          Toast.fail(err.message || '接口请求失败');
        });
    }
  }, [data])

  // 跳转到修改
  const onEdit = () => {
    history.push(`/mine/hotel/${id}/${data.hotel_data.id}`);
  }

  const renderCard = (hotel_data: any, canedit: boolean) => {
    return (
        <Card
            edit={canedit && "修改"}
            type="hotel"
            onEdit={onEdit}
            title={hotel_data?.hotel_title}
            status={hotel_data?.hotel_address}
            // time={`入住：${hotel_data?.choice_time_str}`}
            onClick={onEdit}
        >
            <div style={{ flexDirection: "column", display: 'flex' }}>
                <span style={{ color: "#0D59C8"}}>{hotel_data?.room_name}</span>
                {hotel_data.choice_time_str && (
                    <span>入住日期：{hotel_data.choice_time_str}</span>
                )}
                {hotel_data.out_time_str && (
                    <span>退房日期：{hotel_data.out_time_str}</span>
                )}

                <span>备注信息：{hotel_data.remark || '无'}</span>
            </div>
        </Card>
    );
  };

  return (
    <Layout
      loading={loading}
      meetid={id}
      status={userstatus.is_hotel}
      type="hotel"
      data={[data?.hotel_data || {}]}
      renderCard={renderCard}
    />
  );
}